module.exports = __webpack_public_path__ + "static/media/greenhouse2Step9-2.4f7264b0.png";